import { formatOriginalPrice, formatPriceDrop } from '@/domain/price'
import { type ListingPrice } from '@/generated'

import { ListingTilePriceDrop } from '../styled'
import { type ListingPriceAmount } from './GetPriceLabelValue'

/**
 * Renders a component for a specified listing price amount along with price drop if applicable
 *
 * @param {ListingPrice} price The amount to be displayed.
 * @param {boolean} isFrench - A flag indicating if the price should be formatted for French locale (optional).
 * @returns {JSX.Element} - The rendered specified amount component with price drop if applicable
 */
const SpecifiedAmount = ({ price, isFrench }: ListingPriceAmount) => {
  return (
    <div>
      {price && (
        <div data-testid="shopping-ads-specified-amount">
          <span data-testid="shopping-ads-price">
            {price &&
              formatOriginalPrice(price, {
                isFrench: isFrench,
              })}
          </span>{' '}
          {price && formatPriceDrop(price) && (
            <ListingTilePriceDrop data-testid="shopping-ads-price-drop">
              {formatPriceDrop(price as ListingPrice, { isFrench })}
            </ListingTilePriceDrop>
          )}
        </div>
      )}
    </div>
  )
}

export default SpecifiedAmount
